<template>
  <div>
    <div v-if="!profileChanged">
      <div class="mb-4">
        <h6>{{ getFormTitle() }}</h6>
      </div>

      <el-row>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="Destination"
              name="destination"
              placeholder="enter destination"
              rules="required"></dg-text-field>
        </el-col>

        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="Prefix"
              name="prefix"
              placeholder="enter prefix"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="Division"
              name="division"
              placeholder="enter division"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="Rate"
              name="rate"
              
              placeholder="enter rate"
              rules="required"></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 8 : 8">
          <dg-text-field
              :control="control"
              :field_span="22"
            :label_span="22"
              field_mark="required"
              label="Note"
              name="note"
              type="textarea"
              placeholder="enter note"
              rules="required"></dg-text-field>
        </el-col>
      
      </el-row>

   


      <el-row>
        <el-col :span="24" class="mt-5 border-top">
          <el-col :class="$langConfig.cssClass" :span="20" class="mt-4">
            <dg-label-field class="error-field-validate-message" label="fields_do_not_match_the_required_criteria"
                            v-show="!this.validData"></dg-label-field>
          </el-col>
          <el-col :span="4" class="pt-3 text-right">
            <el-button
                @click="createModule"
                :text="actionButtonLabel"
                :type="actionButtonType"
                icon="el-icon-edit mr-2">{{actionButtonLabel}}</el-button>
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div v-else>
      <h5 class="text-success" v-if="profileChanged">
        Profile Updated <i class="el-icon-circle-check text-success"></i> <br>
        <small>You have to logout and login to see changes</small>
      </h5>
    </div>
  </div>
</template>

<script>


import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';
import module from './../index.js'
import iziToast from 'izitoast'
import countriesList from '@/json/countriesList.json'

export default {
  mixins: [fieldController],
  props: {
    editable: {
      required: false,
    },
    formTitle: {
      required: false,
    },
    isForCurrentActiveUser: {
      required: false,
      type: Boolean,
      default: true
    },
    showPasswordField: {
      required: true,
      type: Boolean
    },
    editMode: {
      required: true,
      type: Boolean
    },
    onEditCallback: {
      required: false,
      default: () => {

      }
    },
    onCreateCallback: {
      required: false
    }
  },
  data() {
    return {
      
      control: this,
      
      dataModel: {
       
      },
      
      amReady: false,
    
      module: {...module},
      profilesOptionsList: []
    }
  },
  beforeMount() {
    
   

    
  },
  mounted() {
    
    
     
          // this.amReady = true
          $vue.nextTick(() => {
            this.bindController()
          })
        


  },
  computed: {
    ...$mapState('ajaxManager', ['loadingRequests']),
   
    actionButtonLabel: function () {
      if (!this.editMode) {
        return 'create';
      } else {
        return 'update'
      }
    },
    actionButtonType: function () {
      if (!this.validData) {
        return 'danger';
      } else {
        return 'primary app-bg-primary'
      }
    }
  },
  methods: {
    
    getFormTitle() {
      if (this.formTitle) {
        return this.formTitle
      } else {
        return ((!this.editMode) ? this.$ml.get('create') : this.$ml.get('edit')) + ' ' + this.module.info.caption
      }
    },
    
    createModule() {
      this.validateFields().then(result => {
      

        let context = this;
        let data = {data: this.dataModel};
        
        if (this.editMode) {
          data.id = this.dataToBind.id;
        }
        if (!result) return

      
        let api = null
        
          api = (this.editMode) ? 'update' : 'create';
        

        this.$store.dispatch(this.module.info.name + '-api/' + api, data).then(response => {
      

          iziToast.success({
            title: this.$ml.get('successfully'),
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true
          });
         if (context.onCreateCallback) {
                context.onCreateCallback(response.data)
              }

        }).catch(error => {
          iziToast.warning({
            title: 'Oops ... failed',
            message: '',
            position: 'topRight',
            close: false,
            timeout: 1900,
            animateInside: true
          });
          console.log('catched error', error)
          this.setfieldsErrorMessage({
            fieldsErrors: error.response.data
          }, this.arefieldsValid);
        })

      })
    }
  }
}
</script>
